import Immutable from "immutable";
import { FormTemplateSettingsType } from "../SettingsTab/schemas";
import { Change, FormTemplateIdType } from "./common";
import * as Draft from "./settingsDraft";

export type SettingsChange = Change<
  FormTemplateSettingsType,
  Draft.SettingsDraft
>;

type StateInternal = {
  settings: Immutable.Map<FormTemplateIdType, SettingsChange>;
};

export type State = Immutable.Record<StateInternal>;

export const NewState = Immutable.Record<StateInternal>({
  settings: Immutable.Map(),
});
